export default "__VITE_ASSET__N1LUJRRj__"